var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthFitness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.5,
    height: 30.5,
    viewBox: "0 0 52.5 30.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Health_Fitness",
    "data-name": "Health & Fitness",
    transform: "translate(-643.75 -2178.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 22,
    height: 8,
    transform: "translate(659 2190)",
    fill: "#ebebeb",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 9,
    height: 28,
    transform: "translate(650 2180)",
    fill: "#ebebeb",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 5,
    height: 24,
    transform: "translate(645 2182)",
    fill: "#ebebeb",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 9,
    height: 28,
    transform: "translate(690 2208) rotate(180)",
    fill: "#ebebeb",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 5,
    height: 24,
    transform: "translate(695 2206) rotate(180)",
    fill: "#ebebeb",
    stroke: "#029c27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthFitness);
export default __webpack_public_path__ + "static/media/Health & Fitness.dce64b595789d680a3b3643d8e61278c.svg";
export { ForwardRef as ReactComponent };